import React from "react";
import ProfilePic from "../Assets/avatar.png";
import { AiFillStar } from "react-icons/ai";

const Testimonial = () => {
  return (
    <div className="work-section-wrapper App">
      <div className="work-section-top">
        <p className="primary-subheading">Testimonial</p>
        <h1 className="primary-heading">What They Are Saying</h1>
        <p className="primary-text">
          A local burger shop experience which turned out to be delicious! I went there initially after it opened and the classic burger was good. They've added more items to their menu now and I tried the Lebanese chicken shawarma and their loaded fries.
        </p>
      </div>
      <div className="testimonial-section-bottom">
        <img style={{
          width:"2.2rem"
        }} src={ProfilePic} alt="" />
        <p>
        A local burger shop experience which turned out to be delicious! I went there initially after it opened and the classic burger was good. They've added more items to their menu now and I tried the Lebanese chicken shawarma and their loaded fries.
        </p>
        <div className="testimonials-stars-container">
          <AiFillStar />
          <AiFillStar />
          <AiFillStar />
          <AiFillStar />
          <AiFillStar />
        </div>
        <h2>Ranjan Matthew</h2>
      </div>
    </div>
  );
};

export default Testimonial;
